import { useMemo } from "react";
import { useSelector } from "react-redux";

import isEmpty from "lodash/isEmpty";

import { usePreviewModeContext } from "@contexts/preview-mode-context";
import { useProductDetailContext } from "@contexts/product-detail-context";

import { isCollectionTypeProduct } from "@helpers/products/types";

import { getCartOrderLineItems, getCartOrderProductSets } from "@selectors/cart";

const useGetCartAddedVariant = ({ intent }) => {
  const { isGuestOrPreviewMode } = usePreviewModeContext();
  const {
    editProductIds: [editProductId],
  } = useProductDetailContext();
  const productSets = useSelector(getCartOrderProductSets);
  const lineItems = useSelector(getCartOrderLineItems);

  const cartAddedVariant = useMemo(() => {
    const orderSets =
      isGuestOrPreviewMode || !isCollectionTypeProduct(intent) ? lineItems : productSets;

    if (editProductId && !isEmpty(orderSets)) {
      return orderSets.find(({ id }) => id === editProductId);
    }
  }, [lineItems, productSets, isGuestOrPreviewMode, editProductId]);

  return cartAddedVariant;
};

export default useGetCartAddedVariant;
